/**
 * Config store - user preferences.
 * State is loaded from server via fullState event.
 * Changes are sent to server via socket events.
 */

import { create } from "zustand";
import { IMAGE_STYLE_OPTIONS, OUTPUT_FORMAT_OPTIONS, DEFAULT_IMAGE_STYLE, DEFAULT_OUTPUT_FORMAT, DEFAULT_FEATURE_FLAGS, type FeatureFlags } from "@amzn/a4k-creator-studio-shared";
export { IMAGE_STYLE_OPTIONS, OUTPUT_FORMAT_OPTIONS };

interface ConfigState {
  imageStyle: string;
  outputFormat: string;
  moderationAvailable: boolean;
  featureFlags: FeatureFlags;
  isLoaded: boolean;

  replaceAll: (config: { imageStyle: string; outputFormat?: string }) => void;
  setModerationAvailable: (available: boolean) => void;
  setFeatureFlags: (flags: FeatureFlags | undefined) => void;
  setImageStyle: (imageStyle: string) => void;
  setOutputFormat: (outputFormat: string) => void;
}

export const useConfigStore = create<ConfigState>((set) => ({
  imageStyle: DEFAULT_IMAGE_STYLE,
  outputFormat: DEFAULT_OUTPUT_FORMAT,
  moderationAvailable: false,
  featureFlags: DEFAULT_FEATURE_FLAGS,
  isLoaded: false,

  replaceAll: (config) => {
    set({
      imageStyle: config.imageStyle || DEFAULT_IMAGE_STYLE,
      outputFormat: config.outputFormat || DEFAULT_OUTPUT_FORMAT,
      isLoaded: true,
    });
  },

  setModerationAvailable: (available) => {
    set({ moderationAvailable: available });
  },

  setFeatureFlags: (flags) => {
    set({ featureFlags: flags ?? DEFAULT_FEATURE_FLAGS });
  },

  setImageStyle: (imageStyle) => {
    set({ imageStyle });
    const { useSocketStore } = require("./socketStore");
    const socket = useSocketStore.getState().socket;
    if (socket) {
      socket.emit("setImageStyle", { imageStyle });
    }
  },

  setOutputFormat: (outputFormat) => {
    set({ outputFormat });
    const { useSocketStore } = require("./socketStore");
    const socket = useSocketStore.getState().socket;
    if (socket) {
      socket.emit("setOutputFormat", { outputFormat });
    }
  },
}));
